import React, { useEffect, useState } from 'react';
import { message, Card, Table, Tabs, Col, Row } from "antd";
import { Button, Dialog, SearchInput } from "evergreen-ui";
import { MDBCol, MDBRow } from "mdbreact";
import FireFetch from "../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import EnterQuiz from "../../Modals/Quizzes/AddQuiz/EnterQuiz";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import { generatePath, useNavigate } from "react-router-dom";
import Ranking from "./Ranking";
import Points from "./Points";
import { utils, writeFile } from "xlsx";
import { useAuth } from '../../AuthContext/AuthContext';
import TableActionMenu from "../../Common/TableActionMenu";

const { TabPane } = Tabs;
var db = getDatabase(Firebase);
const QuizV2 = () => {
	const columns = [
		{
			title: 'Title',
			dataIndex: 'title',
			key: 'title',
			sorter: (a, b) => a.title && a.title.localeCompare(b.title)
		},
		{
			title: 'Questions',
			dataIndex: 'questions',
			key: 'questions',
			sorter: (a, b) => a.questions && a.questions - b.questions && b.questions,
		},
		{
			title: 'Language',
			dataIndex: 'language',
			key: 'language',
			sorter: (a, b) => a.language && a.language.localeCompare(b.language),
		},
		{
			title: 'Lesson',
			dataIndex: 'lesson',
			key: 'lesson',
			sorter: (a, b) => a.lesson && a.lesson.localeCompare(b.lesson),
		}, {
			title: 'Category',
			dataIndex: 'category',
			key: 'category',
			sorter: (a, b) => a.category && a.category.localeCompare(b.category),
		},
		{
			title: 'Attempts',
			dataIndex: 'attempts',
			key: 'attempts',
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		},
	];

	const navigate = useNavigate();
	const [dataArray, setDataArray] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [eventsData, setEventsData] = useState([]);
	const [checkedData, setCheckedData] = useState(false);
	const [quizArray, loading] = useListVals(ref(db, "talmidsdb/quizzes"));
	const [questionArray] = useListVals(ref(db, "talmidsdb/quizQuestions"));
	const [quizGrades] = useListVals(ref(db, "talmidsdb/quizCompletions"));
	const [categoryArray] = useListVals(ref(db, "talmidsdb/categories"))
	const [lessonArray] = useListVals(ref(db, "talmidsdb/lessons"))
	const [languageArray] = useListVals(ref(db, "talmidsdb/languages"))
	const { canAccessModule } = useAuth();
	const canCreateQuiz = canAccessModule("QUIZZES", "create");
	const canDeleteQuiz = canAccessModule("QUIZZES", "delete");

	const callback = (data) => {
		setCheckedData(data);
	}

	const proceedToDetails = (id, object) => {
		navigate(generatePath("/quizzes/:id", { id }), { state: { quiz: object } });
	};

	useEffect(() => {
		setEventsData([]);
		setDataArray([]);

		if (quizArray && languageArray?.length > 0) {
			var tempArray = [];
			quizArray?.map((item, index) => {
				var questionsList = item?.questions ? (Array.isArray(item.questions) ? item.questions : Object.values(item.questions)) : [];
				var filteredQuestions = questionsList.filter(x => x && x.quizID === item?.id);
				var filteredAttempts = quizGrades?.filter(x => x?.quizID === item?.id);
				tempArray.push({
					key: index + 1,
					title: item.title,
					questions: questionsList.filter(Boolean).length,
					attempts: filteredAttempts?.length,
					language: languageArray[languageArray?.findIndex(x => (x.id) === item?.languageID)] &&
						languageArray[languageArray?.findIndex(x => (x.id) === item?.languageID)].languageName,
					lesson: lessonArray[lessonArray?.findIndex(x => (x.id) === item?.lessonID)] &&
						lessonArray[lessonArray?.findIndex(x => (x.id) === item?.lessonID)].lessonName,
					category: categoryArray[categoryArray?.findIndex(x => (x.id) === item.categoryID)] &&
						categoryArray[categoryArray?.findIndex(x => (x.id) === item.categoryID)].name,
					action: (
						<TableActionMenu
							items={[
								{
									key: "view",
									label: "View",
									onClick: () => {
										proceedToDetails(item.quizID, item);
									},
								},
								canDeleteQuiz && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (!canDeleteQuiz) {
											message.error("You do not have permission to delete quizzes.");
											return;
										}

										if (confirm("Are you sure you want to delete this quiz? All questions and grades for this quiz will be deleted!")) {
											FireFetch.DeleteFromDB("quizzes", item.quizID).then((text) => {
												if (text === "success") {
													FireFetch.addLog("quizzes", item.quizID, "Delete");
													message.success("Quiz deleted successfully");
													filteredQuestions.forEach(() => {
														FireFetch.DeleteFromDB("/quizzes/questions");
													});
												} else {
													message.error("Unable to delete quiz");
												}
											}).catch(() => {
												message.error("Unable to delete quiz");
											});
										}
									},
								},
							]}
						/>
					)
				});
				setDataArray([...tempArray]);
				setEventsData([...tempArray]);

			});

		}

	}, [categoryArray, languageArray, lessonArray, questionArray, quizArray, quizGrades]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray.filter(({ title, lesson, language, category }) => {
			title = title?.toLowerCase();
			lesson = lesson?.toLowerCase();
			language = language?.toLowerCase();
			category = category?.toLowerCase();
			return title?.includes(searchText) || lesson?.includes(searchText)
				|| language?.includes(searchText) || category?.includes(searchText);
		});
		setEventsData(filteredEvents);
	};

	const downloadExcel = () => {
		questionArra?.map((quest) => {
			quest.quiz = quizArray?.find(x => x.ID === quest.quizID)?.title;

			//quest = sortObjectByKeys(quest);
			quest?.options?.map((option, index) => {
				quest[`option${index + 1}`] = option;
			});
			quest.answer = `option ${parseInt(quest.answer) + 1}`;
			delete quest.questionID;
			delete quest.questionIndex;
			delete quest.quizID;
			delete quest.timeStamp;
			delete quest.options;
		});

		const worksheet = utils.json_to_sheet(questionArray);
		const workbook = utils.book_new();
		utils.book_append_sheet(workbook, worksheet, "Sheet1");
		writeFile(workbook, "questions.xlsx");
	};

	return (
		<div className="py-4 mx-1 mt-4">
			<Dialog
				isShown={showModal}
				title="Create New Quiz"
				onCloseComplete={() => setShowModal(false)}
				hasFooter={false}
				className="font-Nunito"
			>
				<EnterQuiz modal={setShowModal} />
			</Dialog>
			<Row gutter={[8, 4]}>
				<Col span={24}>
					<MDBRow className="w-100">
						<MDBCol md={12}>
							<Card className="w-100">
								<MDBRow>
									<MDBCol md="10">
										<div className="text-left">
											<div className="d-block">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>Quizzes</h5>
											</div>
										</div>
									</MDBCol>
									<MDBCol>
										<div className="d-flex flex-row">
											{canCreateQuiz && (
												<Button
													appearance="primary"
													className="mx-2"
													onClick={() => setShowModal(true)}
												>
													New Quiz
												</Button>
											)}
										</div>
									</MDBCol>
								</MDBRow>
							</Card>
							<Card>
								<Tabs defaultActiveKey="1" type="card" size="normal">
									<TabPane tab="Quizzes" key="1">
										<div>
											<div style={{ marginBottom: 10 }} className="float-right">
												<SearchInput
													placeholder="Search Quizzes..."
													className="w-100 mx-1"
													width={window.innerWidth - 1000}
													onChange={e => handleSearch(e.target.value)}
												/>
												<Button
													appearance="primary"
													onClick={() => {
														FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
															filename: "Quizzes",
															exportButtons: false,
															sheetname: "Quizzes",
														}), eventsData);
													}}
												>
													Print
												</Button>
												<Button
													appearance="primary"
													className="mx-2"
													onClick={() => {
														downloadExcel();
													}}
												>
													Print Questions
												</Button>
											</div>
											<Table
												style={{ overflow: "auto" }}
												className="custom-table"
												loading={loading}
												pagination={{
													defaultPageSize: 100,
													showSizeChanger: true,
													pageSizeOptions: ['100', '200', '300'],
												}}
												id="dataTable"
												dataSource={eventsData}
												columns={columns}
											/>
										</div>
									</TabPane>
									<TabPane tab="Quiz Grades" key="2">
										<Ranking />
									</TabPane>
									<TabPane tab="Points" key="3">
										<Points />
									</TabPane>
								</Tabs>
							</Card>
						</MDBCol>
					</MDBRow>
				</Col>
			</Row>
		</div>
	);
}

export default QuizV2
